import axios from 'axios';


export const getEventResources = () => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`event-resources`);
};
export const AddEventResources = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`event-resources/create`,
    obj,
    { headers }
  );
};

export const EditEventResources = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`event-resources/update`,
    obj,
    { headers }
  );
};

export const DeleteEventResources = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`event-resources/delete`,
    obj,
    { headers }
  );
};
